type StarRatingSize = 'sm' | 'md' | 'lg';

interface StarRatingProps {
  value: number;
  onChange?: (value: number) => void;
  size?: StarRatingSize;
  className?: string;
}

const SIZE_CLASSES: Record<StarRatingSize, string> = {
  sm: 'w-3.5 h-3.5',
  md: 'w-4 h-4',
  lg: 'w-7 h-7',
};

function StarIcon({ filled, className }: { filled: boolean; className: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 1.5}
    >
      <path d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.9l-5.2 2.73.99-5.79-4.21-4.1 5.82-.85L10 1.5z" />
    </svg>
  );
}

export function StarRating({ value, onChange, size = 'md', className = '' }: StarRatingProps) {
  const interactive = Boolean(onChange);
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className={`inline-flex items-center gap-0.5 text-chocolate ${className}`}>
      {stars.map((star) =>
        interactive ? (
          <button
            key={star}
            type="button"
            onClick={() => onChange!(star)}
            aria-label={`${star} estrela${star > 1 ? 's' : ''}`}
            className="cursor-pointer"
          >
            <StarIcon filled={star <= value} className={SIZE_CLASSES[size]} />
          </button>
        ) : (
          <StarIcon key={star} filled={star <= Math.round(value)} className={SIZE_CLASSES[size]} />
        )
      )}
    </div>
  );
}
